import React, { useEffect } from "react";
import styled, { injectGlobal } from "styled-components";
import { withI18n } from "react-i18next";
import PromoImageB1 from "../../images/promo-b-1.png";
import PromoImageB2 from "../../images/promo-b-2.png";
import PromoImageB3 from "../../images/promo-b-3.png";
import CursorImage from "../../images/cursor.svg";
// import ShareButtonImage from "../../images/share-button.svg";
import { Typography } from "components/Common";
import { useLoadFont } from "helpers/hooks";

interface IProps {
  t?: any;
}

const MARGIN_LEFT_PERCENTAGE = 8;

const ActorSellingFeatures2025OptionB: React.FC<IProps> = ({ t }) => {
  useLoadFont("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap");

  useEffect(() => {
    injectGlobal`
      body {
        background-color: white !important;
      }
    `;

    return () => {
      injectGlobal`
        body {
          background-color: inherit;
        }
      `;
    }
  }, []);

  return (
    <Container>
      <TitleContainer>
        <Title>{t('Today, Standing Out Takes more than a Headshot')}</Title>
      </TitleContainer>
      <IllustrationFrame>
        <ShareBtnWrapper>
          <ShareBtnImage>{t('Share')}</ShareBtnImage>
        </ShareBtnWrapper>
        <CursorImg src={CursorImage} />
        <Photo1 src={PromoImageB1} />
        <Photo2 src={PromoImageB2} />
        <Photo3 src={PromoImageB3} />
      </IllustrationFrame>
    </Container>
  );
};

export default withI18n()(ActorSellingFeatures2025OptionB);

const Container = styled.div`
  position: relative;

  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: nowrap column;
  overflow: hidden;

  @media (min-width: 521px) {
    z-index: -1;
  }

  @media (min-width: 1024px) {
    background-color: #F7F7F7;
  }
`;

const TitleContainer = styled.div`
  flex: 1;
  padding-left: ${MARGIN_LEFT_PERCENTAGE}%;
  display: flex;
  flex-flow: nowrap column;
  justify-content: center;

  margin-top: 32px;

  @media (min-width: 768px) {
    // max-width: 60%;
    width: 40vw;
  }

  @media(min-width: 1024px) {
    margin-top: 0;
  }

  @media (min-width: 1920px) {
    margin-left: auto;
    margin-right: 100px;

    // width: calc(-1502px + 4452vw);
    width: 40vw;
  }
`;

const Title = styled(Typography)`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 30px;
  line-height: 42px;
  vertical-align: center;

  @media (min-width: 768px) {
    // font-size: 2vw;
    font-size: 3.5vh;
    // line-height: 2.5vw;
    line-height: 4.5vh;
  }

  @media (min-width: 1920px) {
    text-align: end;
  }
`;

const IllustrationFrame = styled.div`
  position: relative;
  height: 70%;
  min-height: 300px;
  width: 0;
  margin: 0 auto 40px;

  @media (min-width: 520px) {
    min-height: 400px;
    margin-bottom: 0;
  }

  @media (min-width: 1024px) {
    width: auto;
    margin: 0;
  }
  
  // non-vertical layout, vertical screen (tablets, etc)
  @media (min-width: 1024px) and (min-height: 1024px) and (max-width: 1280px) {
    margin-right: -35vh;
  }
`;

const Photo1 = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 1vh 20vh 20vh 10vh;
  height: 86%;
  transform: translateX(50%);

  @media (min-width: 1024px) {
    transform: translateX(-40%);
    height: 100%;
  }
  
  // non-vertical layout, vertical screen (tablets, etc)
  @media (min-width: 1024px) and (min-height: 1024px) and (max-width: 1280px) {
    transform: translateX(-50%);
  }
`;

const Photo2 = styled.img`
  position: absolute;
  height: 50%;
  bottom: 0;
  right: 0;
  border-radius: 25vh 1vh 1vh 1vh;
  transform: translateX(100%);

  @media (min-width: 1024px) {
    transform: none;
    height: 65%;
  }

  @media (min-width: 1024px) {
    border-radius: 25vh 0 0 0;
  }
`;

const Photo3 = styled.img`
  position: absolute;
  bottom: -10px;
  right: 0;
  height: 34%;
  border-radius: .7vh .7vh .7vh .7vh;
  transform: translateX(-25%);

  @media (min-width: 1024px) {
    transform: translateX(-130%);
  }
`;

// const ShareBtnImg = styled.img`
//   position: absolute;
//   z-index: 1;
//   height: 92%;
//   right: -200px;
//   bottom: -50px;

//   @media (min-width: 520px) {
//     right: -300px;
//   }

//   @media (min-width: 1024px) {
//     bottom: 0;
//     right: 0;
//     height: 92%;
//   }
// `;

const ShareBtnWrapper = styled.div`
  position: absolute;
  z-index: 1;
  right: -300px;
  bottom: -50px;
  height: 92%;
  // width: 36vh;
  width: 280px;

  @media (min-width: 520px) {
    width: 210px;
  }

  @media (min-width: 1024px) {
    height: 90%;
    // width: 25vh;
    width: calc(-87.059px + 39.216vh);
    bottom: 0;
    right: 50px;
  }

  // super narrow wide screen edge case
  @media (max-height: 630px) and (min-width: 1024px) {
    width: 160px;
  }
`;

const ShareBtnImage = styled(Typography)`
  background-color: ${p => p.theme.lightBlue};
  border-radius: 4px;
  display: inline-block;
  color: white;
  padding: 8px 16px;
  font-weight: 700;
  box-shadow: 0px 4px 4px 0px #00000040;
  cursor: default;

  @media (min-width: 1024px) {
    font-size: 2.1vh;
    padding: 2vh 2.8vh;
    border-radius: .5vh;
  }

  &::selection {
    background-color: transparent;
  }
`;

const CursorImg = styled.img`
  position: absolute;
  z-index: 1;
  height: 92%;
  right: -210px;
  bottom: -70px;

  @media (min-width: 520px) {
    right: -315px;
  }

  @media (min-width: 1024px) {
    bottom: 0;
    right: 0;
    height: 85%;
  }
`;
